import { render, staticRenderFns } from "./TaskListAsList.vue?vue&type=template&id=41a38140&scoped=true"
import script from "./TaskListAsList.vue?vue&type=script&lang=js"
export * from "./TaskListAsList.vue?vue&type=script&lang=js"
import style0 from "./TaskListAsList.vue?vue&type=style&index=0&id=41a38140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a38140",
  null
  
)

export default component.exports